import { CircularProgress, Tooltip as OriginalTooltip, styled } from "@mui/material";

import Button from "@/components/button/button";

export const Tooltip = styled(OriginalTooltip)`
  pointer-events: auto;
`;

export const RefreshButton = styled(Button)`
  pointer-events: auto;
  position: relative;
  min-width: 40px;
`;

export const RefreshProgress = styled(CircularProgress)`
  position: absolute;
  transition: none;

  .MuiCircularProgress-circle {
    transition: none;
  }
`;
